import { buildLoader } from '../../util/GenericLoader';
import { fetchHomeAction } from '../../../redux/actions/rtemFiles';

export default buildLoader(fetchHomeAction);
